export default {
  copyright: '2020 「 有了」版权所有',
  powerText: 'Powered by',
  copyright1: '©️2020「有了」版权所有',
  powered: '「有了」提供技术支持',
}
